import React from "react";

import { Activity } from "@mapmycustomers/shared/types/entity";

import styles from "./SearchResult.module.scss";

interface Props {
  activity: Activity;
}

const SearchResult: React.FC<Props> = ({ activity }) => {
  const association = activity.account ?? activity.contact ?? activity.deal;

  return (
    <div className={styles.container}>
      <div className={styles.title}>{activity.name}</div>
      {association && <div className={styles.association}>{association.name}</div>}
    </div>
  );
};

export default SearchResult;
